import { render, staticRenderFns } from "./SSOLanding.vue?vue&type=template&id=1bf86945"
import script from "./SSOLanding.vue?vue&type=script&lang=js"
export * from "./SSOLanding.vue?vue&type=script&lang=js"
import style0 from "./SSOLanding.vue?vue&type=style&index=0&id=1bf86945&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports